import React, { createContext, useReducer } from 'react';
import PropTypes from 'prop-types';
import { cardSettings } from './reducer';

const initSettingsState = {
  currentScreen: '',
  screenOptions: {},
  user: {
    isUS: false,
    cardProvider: null,
    firstName: null,
    lastName: null,
    mailingAddresses: null,
  },
  cardStatus: null,
};

export const CardSettingsContext = createContext(initSettingsState);

export const CardSettingsProvider = ({ children }) => {
  const [state, dispatch] = useReducer(cardSettings?.CardSettingsReducer, initSettingsState);

  const boundActions = {};
  // eslint-disable-next-line guard-for-in, guard-for-in
  for (const key in cardSettings?.actions) {
    boundActions[key] = cardSettings.actions[key](dispatch);
  }

  return (
    <CardSettingsContext.Provider value={{ state, ...boundActions }}>
      {children}
    </CardSettingsContext.Provider>
  );
};

CardSettingsProvider.propTypes = {
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
};
